import { CommonAccountCompanyEntity, EMPTY_COMMON_ACCOUNT_COMPANY_ENTITY } from "domain/entity/CommonAccount/CommonAccountCompanyEntity";
import { CommonAccountEntity, EMPTY_COMMON_ACCOUNT_ENTITY } from "domain/entity/CommonAccount/CommonAccountEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface CommonAccountDropdownOptions {
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
    serviceCodeDropdownOptions: DropdownProps[],
    soaDropdownOptions: DropdownProps[],
    consortiumCodeDropdownOptions: DropdownProps[],
    companyCodeDropdownOptions: DropdownProps[],
}
export interface CommonAccountViewChangeState extends BaseViewChangeSate {
}

export interface CommonAccountModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    isShowCompanyEditPanel: boolean,
    isShowCompanyAddPanel: boolean,
    dynamicOptions: CommonAccountDropdownOptions,
    commonAccountList: CommonAccountEntity[],
    selectedRows: CommonAccountEntity[],
    updatedRows: CommonAccountEntity[],
    currentRow: CommonAccountEntity,
    currentEditRow: CommonAccountEntity,
    currentCompanyRow: CommonAccountCompanyEntity,
    currentCompanyEditRow: CommonAccountCompanyEntity,
    selectedCompanyRows: CommonAccountCompanyEntity[],
    tempCompanyRows: CommonAccountCompanyEntity[],
    masterState: CommonAccountViewChangeState,

}

export const EMPTY_COMMON_ACCOUNT_MODEL: CommonAccountModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    isShowCompanyEditPanel: false,
    isShowCompanyAddPanel: false,
    dynamicOptions: {
        subChargeTypeDropdownOptions: {},
        serviceCodeDropdownOptions: [],
        soaDropdownOptions: [],
        consortiumCodeDropdownOptions: [],
        companyCodeDropdownOptions: [],
    },
    commonAccountList: [],
    selectedRows: [],
    updatedRows: [],
    currentRow: { ...EMPTY_COMMON_ACCOUNT_ENTITY },
    currentEditRow: { ...EMPTY_COMMON_ACCOUNT_ENTITY },
    currentCompanyEditRow: { ...EMPTY_COMMON_ACCOUNT_COMPANY_ENTITY },
    selectedCompanyRows: [],
    tempCompanyRows: [],
    currentCompanyRow: { ...EMPTY_COMMON_ACCOUNT_COMPANY_ENTITY },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}